export const DAYS = ['Monday','Tuesday','Wednesday','Thursday','Friday','Saturday','Sunday'];

export const DAYS_ES = ['Lunes','Martes','Miércoles','Jueves','Viernes','Sábado','Domingo'];

export const DAY_LABELS = ['Lun','Mar','Mié','Jue','Vie','Sáb','Dom'];

export const CATEGORIES = ['All','Chest','Back','Legs','Shoulders','Arms','Core','Cardio','Mobility'];

export const CATEGORY_LABELS = {
  'All': 'Todos', 'Chest': 'Pecho', 'Back': 'Espalda', 'Legs': 'Piernas',
  'Shoulders': 'Hombros', 'Arms': 'Brazos', 'Core': 'Core', 'Cardio': 'Cardio',
  'Mobility': 'Movilidad',
  'chest': 'Pecho', 'back': 'Espalda', 'legs': 'Piernas', 'shoulders': 'Hombros',
  'arms': 'Brazos', 'core': 'Core', 'cardio': 'Cardio', 'other': 'Otro', 'Other': 'Otro',
  'mobility': 'Movilidad',
};

export const SORT_OPTIONS = [
  { value: 'alpha', label: 'A-Z' },
  { value: 'usage', label: 'Más usados' },
  { value: 'pr', label: 'Mejor PR' },
  { value: 'newest', label: 'Recientes' },
];
